import storage from 'services/storage';

// The subset of the searchNLP slice worth surviving a refresh: session records (conversations,
// follow-ups, feedback telemetry), the pointers that make them reachable, and recent searches.
// Modal and other transient UI flags deliberately reset with the page.
export const pickPersistedState = searchNLP => ({
  sessions: searchNLP.sessions,
  activeSessionId: searchNLP.activeSessionId,
  confirmedSessionId: searchNLP.confirmedSessionId,
  recentSearches: searchNLP.recentSearches,
});

// Reference compares are enough: the reducer never mutates in place.
const persistedSubsetChanged = (before, after) =>
  before.sessions !== after.sessions ||
  before.activeSessionId !== after.activeSessionId ||
  before.confirmedSessionId !== after.confirmedSessionId ||
  before.recentSearches !== after.recentSearches;

/**
 * Persist the searchNLP slice whenever its persisted subset changes, regardless of which action
 * changed it. The per-thunk persistState pattern other slices use cannot work here: the slice
 * mutates from its own (mostly plain) action creators AND from cross-slice search actions like
 * CLEAR_FILTERS, so persistence has to follow the state, not the call sites. Writes are
 * coalesced per macrotask so one user gesture — which dispatches several actions — stores once,
 * reading the final state at flush time.
 */
export const searchNLPPersistenceMiddleware = store => {
  let writeQueued = false;
  return next => action => {
    const before = store.getState().searchNLP;
    const result = next(action);
    const after = store.getState().searchNLP;
    if (!writeQueued && persistedSubsetChanged(before, after)) {
      writeQueued = true;
      setTimeout(() => {
        writeQueued = false;
        storage.setItem(
          'searchNLP',
          pickPersistedState(store.getState().searchNLP)
        );
      }, 0);
    }
    return result;
  };
};
